<div class="h-100">
  <kl-create-stock
    [pageId]="dialogData?.data?.pageId"
    [stockId]="dialogData?.data?.stockId"
    (stockCreated)="ok()">
  </kl-create-stock>
</div>
